import { Typography } from "@mui/material";
import { StyledData } from "../../styled/Labels";

const DataLabel = ({ firstText, secondText, thirdText, icon }) => {

  return (
    <StyledData.DataContainer>
      <Typography style={{ fontSize: 13 }}>{firstText}</Typography>
      <Typography style={{ fontSize: 13 }}>{secondText}</Typography>
      {!!thirdText &&
        (
          <StyledData.LastTypo>
            <Typography style={{ fontSize: 13 }}>{thirdText}</Typography>
            {icon && icon}
          </StyledData.LastTypo>
        )
      }

    </StyledData.DataContainer>
  );
};

export default DataLabel;
